import dayjs from 'dayjs'
import { ArticleListResponse } from '@/modules/sales/clients/services/apiValidation/apiValidationSchemas.ts'

type QuoteStatus = 'PAGADA' | 'ATRASADA' | 'PENDIENTE'

type ScenarioQuote = {
  /** Días respecto a hoy (negativo = pasado). */
  days: number
  status: QuoteStatus
  quote?: string
  paid?: string
  type?: string
}

type RefinanceScenario = {
  creditId: string
  label: string
  refinancingAmount: number
  quotes: ScenarioQuote[]
}

const fmt = (days: number) => dayjs().add(days, 'day').format('DD/MM/YYYY')

// Un escenario por caso borde de la fecha de inicio / saldo del refinanciamiento.
// Se listan como créditos de motor (los únicos con la acción "Refinanciar").
export const refinanceScenarios: RefinanceScenario[] = [
  {
    creditId: '9001',
    label: 'Solo pendientes (1ra vence mañana)',
    refinancingAmount: 0,
    quotes: [1, 8, 15, 22].map((days) => ({ days, status: 'PENDIENTE' }))
  },
  {
    creditId: '9002',
    label: 'Solo pendientes (1ra vence en 45 días)',
    refinancingAmount: 1,
    quotes: [45, 52, 59, 66].map((days) => ({ days, status: 'PENDIENTE' }))
  },
  {
    creditId: '9003',
    label: 'Una atrasada, sin pendientes',
    refinancingAmount: 0,
    quotes: [
      { days: -40, status: 'PAGADA', paid: '50.00' },
      { days: -10, status: 'ATRASADA', paid: '20.00' }
    ]
  },
  {
    creditId: '9004',
    label: 'Atrasada de ayer + pendientes',
    refinancingAmount: 0,
    quotes: [
      { days: -1, status: 'ATRASADA' },
      { days: 6, status: 'PENDIENTE' },
      { days: 13, status: 'PENDIENTE' }
    ]
  },
  {
    creditId: '9005',
    label: 'Todo pagado (saldo 0)',
    refinancingAmount: 0,
    quotes: [
      { days: -30, status: 'PAGADA', paid: '50.00' },
      { days: -23, status: 'PAGADA', paid: '50.00' }
    ]
  },
  {
    creditId: '9006',
    label: 'Atrasada de otro tipo ignorada',
    refinancingAmount: 0,
    quotes: [
      { days: -20, status: 'ATRASADA', type: 'MISCELLANEOUS' },
      { days: 10, status: 'PENDIENTE', paid: '15.00' },
      { days: 17, status: 'PENDIENTE' }
    ]
  },
  {
    creditId: '9007',
    label: 'Varias atrasadas hace meses',
    refinancingAmount: 2,
    quotes: [
      { days: -120, status: 'ATRASADA', paid: '10.00' },
      { days: -90, status: 'ATRASADA' },
      { days: -60, status: 'ATRASADA' },
      { days: 5, status: 'PENDIENTE' }
    ]
  }
]

export const refinanceScenarioQuotesResponse = (
  scenario: RefinanceScenario
) => ({
  message: 'OK',
  data: {
    refinancingAmount: scenario.refinancingAmount,
    quotes: scenario.quotes.map((q, i) => ({
      id: Number(scenario.creditId) * 10 + i + 1,
      name: `Cuota ${i + 1} de ${scenario.quotes.length}`,
      quote: q.quote ?? '50.00',
      status: q.status,
      dueAt: fmt(q.days),
      paymentDate: q.status === 'PAGADA' ? fmt(q.days) : null,
      paid: q.paid ?? (q.status === 'PAGADA' ? (q.quote ?? '50.00') : '0.00'),
      type: q.type ?? 'PRODUCT'
    }))
  }
})

export const refinanceScenarioCredits: ArticleListResponse['results'] =
  refinanceScenarios.map(({ creditId, label }) => ({
    creditId,
    brandName: 'Suzuki',
    modelId: '2197',
    modelName: `GN125 - ${label}`,
    registerNumber: `REFI-${creditId}`,
    branchOfficeName: 'Weppa',
    cost: '1000.00',
    discountedCredit: '1000.00',
    additionalCost: '0.00',
    initial: '400.00',
    initialTotal: '400.00',
    totalPayment: '820.00',
    createByName: 'Yosvani Nasco',
    extraPayment: null,
    paymentByQuotes: '600.00',
    clientId: '131',
    categoryId: null,
    hasPendingSupportRequest: false,
    rentabilityId: '2',
    createdAt: '25/03/2026',
    productTypeId: '6',
    productTypeName: 'Motor',
    reinstallPending: false,
    isFraud: false,
    hasLateQuote: false,
    supplierCode: 'AUT',
    isFromNuovoToEquality: true,
    statusCredit: 'Paid',
    unpayCredit: false,
    isCollectionAgency: false,
    collectionAgencyName: null,
    weppaPlus: false
  }))
